import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import RegisterReducer from './RegisterReducer';
import { registerReducerKey } from './RegisterConstants';
import RegisterContainer from './RegisterContainerBase';
import { setData, init, cancel, submit, resetState } from './RegisterActions';

import {
  ipAddress as ipAddressSelector,
  isLoading as isLoadingSelector,
  data as dataSelector,
  isAnonymousUser as isAnonymousUserSelector,
  isShibboleth as isShibbolethSelector,
  registerFail as registerFailSelector,
} from './RegisterSelectors';

const mapStateToProps = (state) => ({
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  data: dataSelector(state),
  isAnonymousUser: isAnonymousUserSelector(state),
  isShibboleth: isShibbolethSelector(state),
  registerFail: registerFailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setData: (data) => dispatch(setData(data)),
  init: () => dispatch(init()),
  cancel: () => dispatch(cancel()),
  submit: () => dispatch(submit()),
  resetState: () => dispatch(resetState()),
});

export default compose(
  withCombinedRouteParams,
  withReducer(registerReducerKey, RegisterReducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(RegisterContainer);
